import React, { Component } from "react";
import Button from "components/Common/Button";
import PropTypes from "prop-types";
import tinycolor from "tinycolor2";
import classNames from "classnames";
import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";

/**
 * Creates a generic pill.
 */
class Pill extends Component {
  /**
   * Returns if the pills backgroundColor is light or dark.
   * @returns {bool} true if light false if dark
   */
  get isPillLight() {
    const { pillColor } = this.props;

    return tinycolor(pillColor).isLight();
  }

  /**
   * Renders the pill
   * @returns {React.Component}
   */
  render() {
    const {
      customClassName, pillColor, description, id, buttonOnClick,
      buttonfillColor, icon
    } = this.props;
    const pillStyle = {
      backgroundColor: pillColor
    };
    const buttonColour = this.isPillLight ? colors.colorBlack : colors.colorWhite;

    return (
      <div
        style={pillStyle}
        className={classNames(
          "Pill",
          this.isPillLight ? "Pill--light" : "Pill--dark",
          { [customClassName]: customClassName }
        )}
      >
        {description}
        <Button
          id={id}
          customClassName="Pill__button"
          onClick={() => buttonOnClick(id)}
          title="Remove Pill"
          fillColor={buttonfillColor || buttonColour}
          icon={icon}
          size="small"
          clear
          small
        />
      </div>
    );
  }
}

Pill.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonfillColor: PropTypes.string,
  icon: PropTypes.string,
  buttonOnClick: PropTypes.func.isRequired,
  pillColor: PropTypes.string,
  customClassName: PropTypes.string
};

Pill.defaultProps = {
  buttonfillColor: null,
  icon: "NoEntry",
  pillColor: "",
  customClassName: null
};

export default Pill;
